import * as PIXI from "pixi.js";

export class TranslatableText {

  constructor(text, style, lang, game) {
    this.build(text, style, lang, game);
  }

  /**
   * Create text element
   * Used later for translating the game interface
   * @param text
   * @param style
   * @param lang
   * @param game
   */
  build(text, style, lang, game) {
    // Create new text
    const newText = new PIXI.Text({
      text: text,
      style: style,
    });

    // Hidden by default
    newText.alpha = 0.0;

    // Add text to array, used later for language switcher
    this.newText = newText;
    game.interfaceText[lang].push(newText);
  }

  /**
   * Return PIXI Text Obj
   * @returns {Text}
   */
  getText() {
    return this.newText;
  }
}
